var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('page-footer-layout');
import { breakpoints, theme } from '@shapeable/theme';
import { SiteFooterNavigation } from './site-footer-navigation';
import { OrganisationPoweredBy } from './organisation-powered-by';
import { OrganisationSiteCreator } from './organisation-site-creator';
import { Logo } from '../elements/logo';
import { SocialLinks } from '../elements/social-links';
import { useFooterMenu } from '../../hooks/use-footer-menu';
import { useLang } from '../../hooks/use-lang';
import { useLink } from '../../hooks/use-link';
import { SliceLayout } from './slice-layout';
import { ContentNode } from './content-node';
import { useFooterSecondaryMenu } from '../../hooks/use-footer-secondary-menu';
import { useActiveEntity } from '../../hooks/use-active-entity';
import { useSiteFooterContent } from '../../hooks/use-site-footer-content';
import { useSiteCreator } from '../../hooks/use-site-creator';
import { useSitePoweredBy } from '../../hooks/use-site-powered-by';
import { useSite } from '../../hooks/use-site';
export var SiteFooterLayoutDefaultProps = {
  backgroundColor: '#F5F5F5',
  logoVariant: 'default',
  poweredBylogoProps: {}
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["  \n    font-size: 0.85em;\n    font-weight: 300;\n    padding: ", " 0 0;\n    ", "\n  "], ["  \n    font-size: 0.85em;\n    font-weight: 300;\n    padding: ", " 0 0;\n    ", "\n  "])), theme.UNIT(4), function (_a) {
    var _backgroundColor = _a._backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.BG(_backgroundColor));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: 0;\n    font-size: 0.85em;\n  "], ["\n    padding-top: 0;\n    font-size: 0.85em;\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 0.95em;\n  "], ["\n    font-size: 0.95em;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n    align-self: stretch;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n    align-self: stretch;\n    justify-content: space-between;\n  "]))),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 180px;\n    height: auto;\n    position: relative;\n    transition: filter 0.2s;\n    margin-bottom: ", ";\n    \n    &:hover {\n      filter: saturate(2);\n    }\n\n    ", "\n\n  "], ["\n    width: 180px;\n    height: auto;\n    position: relative;\n    transition: filter 0.2s;\n    margin-bottom: ", ";\n    \n    &:hover {\n      filter: saturate(2);\n    }\n\n    ", "\n\n  "])), theme.UNIT(3), function (_a) {
    var horizontalOffsetMobile = _a.horizontalOffsetMobile;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      left: ", "px;\n    "], ["\n      left: ", "px;\n    "])), horizontalOffsetMobile);
  }),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 160px;\n    margin-bottom: 0;\n  "], ["\n    width: 160px;\n    margin-bottom: 0;\n  "]))),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 220px;\n  "], ["\n    width: 220px;\n  "]))),
  desktopLarge: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 220px;\n  "], ["\n    width: 220px;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "])), theme.UNIT(3)),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-bottom: 0;\n    align-items: center;\n  "], ["\n    margin-bottom: 0;\n    align-items: center;\n  "])))
});
var FooterContentStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    color: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    p {\n      margin-bottom: ", ";\n    }\n  "], ["\n    color: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    p {\n      margin-bottom: ", ";\n    }\n  "])), theme.COLOR('text'), theme.UNIT(2), theme.UNIT(2), theme.UNIT(3)),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "])))
});
var SocialLinksStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var NavigationStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme.UNIT(2), theme.UNIT(2)),
  tablet: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PoweredByStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    transition: filter 0.2s;\n    \n    &:hover {\n      filter: saturate(2);\n    }\n  "], ["\n    transition: filter 0.2s;\n    \n    &:hover {\n      filter: saturate(2);\n    }\n  "])))
});
var SiteCreatorStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    font-weight: 400;\n    color: ", ";\n  "])), theme.COLOR('text')),
  tablet: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    justify-content: center;\n  "], ["\n    justify-content: center;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled(SliceLayout)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Logo: styled(Logo)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  PoweredBy: styled(OrganisationPoweredBy)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), PoweredByStyles),
  SiteCreator: styled(OrganisationSiteCreator)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), SiteCreatorStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  FooterContent: styled(ContentNode)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), FooterContentStyles),
  Navigation: styled(SiteFooterNavigation)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles),
  SocialLinks: styled(SocialLinks)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), SocialLinksStyles)
};
export var SiteFooterLayout = function SiteFooterLayout(props) {
  var className = props.className,
      children = props.children,
      logoVariant = props.logoVariant,
      backgroundColor = props.backgroundColor;
  var menu = useFooterMenu();
  var secondaryMenu = useFooterSecondaryMenu();
  var t = useLang();
  var Link = useLink().Link;
  var currentEntity = useActiveEntity();
  var logoHorizontalOffsetMobile = useSite().logoHorizontalOffsetMobile;
  var footerContent = useSiteFooterContent();
  var finalFooterContent = footerContent.replace(/\{year\}/g, new Date().getFullYear().toString());
  var siteCreator = useSiteCreator();
  var sitePoweredBy = useSitePoweredBy();
  return React.createElement(My.Container, {
    verticalPadding: 'small',
    verticalBalanceDelta: 0,
    entity: currentEntity,
    _backgroundColor: backgroundColor
  }, React.createElement(My.Layout, {
    className: cls.name(className)
  }, React.createElement(My.Logo, {
    horizontalOffsetMobile: logoHorizontalOffsetMobile || 0,
    variant: logoVariant
  }), React.createElement(My.Body, null, React.createElement(My.Navigation, {
    entity: menu
  }), React.createElement(My.Navigation, {
    entity: secondaryMenu
  }), React.createElement(My.FooterContent, {
    entity: {
      text: finalFooterContent
    }
  }), children, React.createElement(My.SocialLinks, null)), sitePoweredBy && React.createElement(My.PoweredBy, {
    entity: sitePoweredBy
  })), siteCreator && React.createElement(My.SiteCreator, {
    entity: siteCreator
  }));
};
SiteFooterLayout.defaultProps = SiteFooterLayoutDefaultProps;
SiteFooterLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;